import { render, staticRenderFns } from "./NeoparentTiptap.vue?vue&type=template&id=6a02cc8a&scoped=true"
import script from "./NeoparentTiptap.vue?vue&type=script&lang=js"
export * from "./NeoparentTiptap.vue?vue&type=script&lang=js"
import style0 from "./NeoparentTiptap.vue?vue&type=style&index=0&id=6a02cc8a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a02cc8a",
  null
  
)

export default component.exports